<template>
  <div v-if="loading" class="will-upload-progress">
    <v-progress-circular
      indeterminate
      color="primary"
      :size="22"
      :width="3"
      class="mr-3"
    />
    <span class="will-upload-progress-text">{{ message }}</span>
  </div>
</template>

<script>
  export default {
    name: 'WillUploadProgress',
    props: {
      loading: {
        type: [Boolean, String],
        default: false,
      },
      message: {
        type: String,
        default: 'Uploading your will, this can take a few seconds.',
      },
    },
  };
</script>

<style lang="scss" scoped>
  .will-upload-progress {
    display: flex;
    align-items: center;
    margin-top: 4px;
    margin-bottom: 12px;
  }

  .will-upload-progress-text {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
  }
</style>
